// AccountDataCard.js
import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { useAuthenticator } from '@aws-amplify/ui-react';

function AccountDataCard() {
  const { user } = useAuthenticator((context) => [context.user]);
  const [customerCode, setCustomerCode] = useState('');

  useEffect(() => {
    const localCustomerCode = localStorage.getItem('customerCode');
    if (localCustomerCode) {
      setCustomerCode(localCustomerCode);
    } else {
      console.warn('No customerCode found in localStorage');
    }
  }, []);

  return (
    <Card sx={{ boxShadow: 3, borderRadius: 5 }}>
      <CardContent>
        <Typography variant="h4" component="div" style={{paddingLeft:'20px'}}>
          {user?.username || user?.attributes?.email || 'Guest'}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary" style={{fontSize:'0.8em',paddingLeft:'20px'}}>
          ID: {customerCode || 'N/A'}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default AccountDataCard;
